function DazXC(signedLink) {
    this.signedLink = signedLink;
    window.dazXC = () => {
        return this;
    }
}

DazXC.prototype.data = function (inData) {
    const result = Object.assign({}, this.signedLink, inData);
    result.hash = dazethutil.hashAll(Object.values(result))
    return result;
}
